
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/auth/register",
      function () {
        return require("private-next-pages/next/auth/register/index.tsx");
      }
    ]);
  